/**
 * Blur-up LQIP: add .is-loaded to .c-image when .c-image__full has loaded.
 * Run on a container (document or overlay content) so it works for static and dynamic content.
 * Uses a slight delay and stagger so the blur is visible and multiple images reveal in sequence.
 */
const BASE_DELAY_MS = 0;
const STAGGER_MS = 0;

function markBlurUpLoaded(wrapper) {
  if (wrapper && !wrapper.classList.contains("is-loaded")) {
    wrapper.classList.add("is-loaded");
    if (wrapper.closest(".c-production__media-item")) {
      window.dispatchEvent(new Event("resize"));
    }
  }
}

function revealAfterDelay(wrapper, index) {
  const delay = BASE_DELAY_MS + index * STAGGER_MS;
  setTimeout(() => markBlurUpLoaded(wrapper), delay);
}

export function initBlurUp(container = document) {
  const root = container?.querySelectorAll ? container : document;
  const fullImages = root.querySelectorAll(".c-image--blur-up .c-image__full");

  fullImages.forEach((img, index) => {
    const wrapper = img.closest(".c-image");
    if (!wrapper || wrapper.classList.contains("is-loaded")) {
      return;
    }

    const hasSource = img.src || img.currentSrc || img.getAttribute("data-src");
    const alreadyLoaded = hasSource && img.complete && img.naturalWidth > 0;

    if (alreadyLoaded) {
      revealAfterDelay(wrapper, index);
      return;
    }

    img.addEventListener("load", () => revealAfterDelay(wrapper, index));
    img.addEventListener("error", () => revealAfterDelay(wrapper, index));
  });
}
